export const BroadcastEvents = {
    FinishOnboarding: 'finishOnboarding',
}
